module.exports = __webpack_public_path__ + "media/components/src/assets/images/blogs/6-668af7a4cfa2d90005d8181e86eb3145.jpg";